import { landingApiRequest } from '@/lib/landing-api'

export type PendingCampaignQuestion = {
  id: number
  title: string
  options: { id: number; label: string }[]
}

type PendingQuestionsResponse = { questions: PendingCampaignQuestion[] }

export function fetchPendingCampaignQuestions(campaignId: number): Promise<PendingQuestionsResponse> {
  return landingApiRequest(`/api/me/campaigns/${campaignId}/questionnaire`)
}

export function saveCampaignQuestionAnswer(
  campaignId: number,
  questionId: number,
  optionId: number
): Promise<PendingQuestionsResponse> {
  return landingApiRequest(`/api/me/campaigns/${campaignId}/questionnaire/responses`, {
    method: 'POST',
    body: JSON.stringify({ question_id: questionId, option_id: optionId }),
  })
}
